import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export function EmailConfirmation() {
  return (
    <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto text-center">
        <div className="flex justify-center">
          <CheckCircle className="h-16 w-16 text-green-600" />
        </div>
        <h1 className="mt-4 text-3xl font-extrabold text-gray-900 mb-2">
          Tack för din registrering!
        </h1>
        <p className="mt-2 text-lg text-gray-500">
          Ett e-postmeddelande för verifiering har skickats till din e-postadress
        </p>
        <p className="mt-4 text-gray-500">
          För att slutföra registreringen, vänligen klicka på länken i e-postmeddelandet.
          Om du inte hittar e-postmeddelandet, kontrollera din skräppostmapp.
        </p>
        <div className="mt-8 space-x-4">
          <Link
            to="/login"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700"
          >
            Gå till inloggning
          </Link>
          <Link
            to="/"
            className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Tillbaka till startsidan
          </Link>
        </div>
      </div>
    </div>
  );
} 